module.exports = "#contabilidaddiv {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 768px; }\n\n#frame {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 768px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admincontabilidad/admincontabilidad.component.scss
// module id = ./src/app/admincontabilidad/admincontabilidad.component.scss
// module chunks = main